import MagaluService from '@magalu/webzord';
export var useOpenLink = function (params) {
    var _a = params || {}, url = _a.url, _b = _a.isInternal, isInternal = _b === void 0 ? true : _b, _c = _a.isDocument, isDocument = _c === void 0 ? false : _c;
    if (url) {
        MagaluService.request({
            serviceName: 'miniapp.openLink',
            serviceArgs: {
                url: url,
                is_internal: isInternal,
                is_document: isDocument,
            },
            callbackId: 'open-link',
        });
    }
};
